export default __webpack_public_path__ + "static/media/csok.71cbfa79.webp";